var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1301",
    "data-name": "Group 1301",
    transform: "translate(-215 -210)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(215 210)",
    fill: "#fbfcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "help-alt",
    d: "M8,0a8,8,0,1,0,8,8A8.009,8.009,0,0,0,8,0ZM8,15.059A7.059,7.059,0,1,1,15.059,8,7.066,7.066,0,0,1,8,15.059ZM9.09,11.5a.971.971,0,1,1-.97-.971A.971.971,0,0,1,9.09,11.5Zm.945-7.533a2.268,2.268,0,0,1,.518,1.746,3.557,3.557,0,0,1-1.29,1.923,1.9,1.9,0,0,0-.879,1.55H7.442a2.8,2.8,0,0,1,1.19-2.249,2.7,2.7,0,0,0,1-1.439A1.407,1.407,0,0,0,9.3,4.552,1.425,1.425,0,0,0,8.121,4,1.569,1.569,0,0,0,6.359,5.514l-.941-.025a2.511,2.511,0,0,1,2.7-2.43,2.391,2.391,0,0,1,1.913.908Z",
    transform: "translate(215 210)",
    fill: "#0923e6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpInfo);
export default __webpack_public_path__ + "static/media/help-info.5fd43cf8e5d85b250d9653fc3d054c60.svg";
export { ForwardRef as ReactComponent };